export const GET_ALL_MAIN_CATEGORIES = "GET_ALL_MAIN_CATEGORIES";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_ALL_SINGLE_CATEGORIES = "GET_ALL_SINGLE_CATEGORIES";
export const GET_ALL_SINGLE_SUB_CATEGORIES = "GET_ALL_SINGLE_SUB_CATEGORIES";
export const GET_ALL_SINGLE_SUB_ITEMS = "GET_ALL_SINGLE_SUB_ITEMS";